import ApiService from './ApiService';

export default class RevenueApi extends ApiService {
    constructor() {
        super('system');
    }

    getAllRevenue(payload) {
        return this.get('revenues', payload);
    }

    getRevenueByOrder(orderId) {
        return this.get(`revenue-commission/${orderId}`);
    }

    closeSales(orderIds) {
        return this.put('revenue-commission/close-sales', { orderIds });
    }

    exportExcelRevenues(payload) {
        return this.get('revenues/export-file/excel', payload, { responseType: 'blob' });
    }

    exportPdfRevenues(payload) {
        return this.get('revenues/export-file/pdf', payload, { responseType: 'blob' });
    }
}
